import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Paragraph from '@marvelapp/marvel-ui/paragraph';

import Card from 'marketing-website/components/modules/Card';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Image from 'marketing-website/components/modules/Image';

import styles from './styles/general.module.css';

export default class ResourcesCard extends Component {
  state = {
    isHovered: false,
  };

  toggleIsHovered = () => {
    this.setState({ isHovered: !this.state.isHovered });
  };

  render() {
    const { excerpt, title, url, artwork } = this.props;
    return (
      <MarvelLink url={url} block>
        <div
          onMouseOver={this.toggleIsHovered}
          onMouseOut={this.toggleIsHovered}
          className={styles.spacing}
        >
          <Card
            size="mediumLarge"
            withBorder
            withBorderRadius={false}
            withMargin={false}
            withShadow={this.state.isHovered}
          >
            <Image {...artwork} maxWidth={250} hasShadow={false} />
            <MaxWidth value={250}>
              <Spacing type="padding" position="topBottom" size="s">
                <Spacing type="padding" position="bottom" size="xs">
                  <Heading weight="semibold" size="xl">
                    {title}
                  </Heading>
                </Spacing>
                <Paragraph size="m" color="slate">
                  {excerpt}
                </Paragraph>
              </Spacing>
            </MaxWidth>
          </Card>
        </div>
      </MarvelLink>
    );
  }
}

ResourcesCard.propTypes = {
  artwork: PropTypes.object,
  excerpt: propTypeEmptyString,
  title: propTypeEmptyString,
  url: propTypeEmptyString,
};



// WEBPACK FOOTER //
// ./src/pages/resources/_ResourcesCard.js